import React, { useEffect, useRef, useState } from "react";

import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import TopBar from "../TopBar";
import { useNavigate } from "react-router-dom";
import AiDubbingTools from "./AiDubbingTools";
// import { setCurrentTab } from "../store/Subtitle/subTitleSlice";

const AiDubbing = () => {
  const [isModalVisible, setIsModalVisible] = useState(true);
  const navigate = useNavigate();
  const {
    selectedVideo = null,
    selectedVideoUrl = null,
    target_language,
  } = useSelector((state) => state.aiDubbing);

  console.log("selectedVideoUrl", selectedVideoUrl);
  const [isPlaying, setIsPlaying] = useState(false);
  const vidRef = useRef();
  const dispatch = useDispatch();

  const handlePlayVideo = () => {
    vidRef?.current?.play();
    setIsPlaying(true);
  };
  const handleVideoEnd = () => {
    setIsPlaying(false);
  };

  const onDashboardRedirect = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-100 relative h-full">
      <TopBar onDashboardRedirect={onDashboardRedirect} aiDubbing={true} />
      {/* {!isPlaying && selectedVideoUrl && (
        <button
          className="bottom-[122px] absolute inset-0 m-auto w-24 h-24 bg-red-700 text-white rounded-full hover:bg-blue-700 flex items-center justify-center z-50"
          style={{}}
          onClick={handlePlayVideo}
        >
          <FontAwesomeIcon
            style={{
              height: "3em",
              paddingLeft: `${isPlaying ? "0" : "0.5em"}`,
            }}
            icon={isPlaying ? faPause : faPlay}
          />
        </button>
      )}
      <div className="bg-[#d0d0d0] w-[833.5px] h-[467.2px] mt-6 mx-auto">
        {!!selectedVideoUrl && (
          <video
            ref={vidRef}
            className="w-full h-full"
            // src={process.env.REACT_APP_SERVER_API_URL + selectedVideoUrl}
            src={selectedVideoUrl}
            // type={selectedVideoUrl.type}
            onEnded={handleVideoEnd}
          />
        )}
      </div> */}
      {selectedVideo && target_language && (
        <div className=" m-auto w-100 h-100  rounded-full flex items-center justify-center ">
          {
            "Click on the Generate AI Dubbing Video, Visible on top of this Screen (right side)"
          }{" "}
        </div>
      )}
      <AiDubbingTools
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </div>
  );
};

export default AiDubbing;
